"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var _styledTools = require("styled-tools");

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas-lab/typography");

const Root = _stylitas.styled.div`
  cursor: pointer;
  flex: 1;
  background-color: ${(0, _styledTools.theme)('colorNeutralWhite')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-style: solid;
  border-bottom-width: ${(0, _styledTools.ifProp)('isActive', '2px', '1px')};
  border-bottom-color: ${(0, _styledTools.ifProp)('isActive', (0, _styledTools.theme)('colorBrandPrimaryDefault'), (0, _styledTools.theme)('colorNeutral10'))};
`;
exports.Root = Root;
Root.Label = (0, _stylitas.styled)(_typography.Typography)`
  display: flex;
  align-items: center;
`;